	function str_encrypt(str) {
                var c = String.fromCharCode(str.charCodeAt(0) + str.length);

                for (var i = 1; i < str.length; i++) {
                    c += String.fromCharCode(str.charCodeAt(i) + str.charCodeAt(i - 1));
                }

                return encodeURIComponent(c);
            }
	function str_decrypt(str) {
                str = decodeURIComponent(str);
                var c = String.fromCharCode(str.charCodeAt(0) - str.length);

                for (var i = 1; i < str.length; i++) {
                    c += String.fromCharCode(str.charCodeAt(i) - c.charCodeAt(i - 1));
                }
                return c;
            }